export default __webpack_public_path__ + "static/media/linkedin.a55160cb.svg";